import { FeatureFlagKey, useFeatureFlags } from "hooks/useFeatureFlags";
import { PropsWithChildren, ReactElement } from "react";
import { Navigate } from "react-router-dom";

export function HasFlag({
  flag,
  fallback,
  children,
}: PropsWithChildren<{
  flag: FeatureFlagKey;
  fallback?: string | ReactElement;
}>) {
  const { featureFlags, loading } = useFeatureFlags();

  if (loading) {
    return <></>;
  } else if (featureFlags?.[flag]) {
    return <>{children}</>;
  } else {
    // If fallback is a React element, render it directly
    if (fallback && typeof fallback !== "string") {
      return fallback;
    }
    // Otherwise, default to Navigate behavior
    return <Navigate to={(fallback as string) ?? "../not-found"} replace />;
  }
}
